/// REACT ///
import { useState } from "react";
/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// ACTIONS ///
import { createPortalSession } from "api/actions/billing";
/// MUI ///
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
/// HOC ///
import LoadingPage from "components/universal/loading_page";

export default function Unpaid() {
  const dispatch = useAppDispatch();
  const [load, setLoad] = useState<boolean>(false);
  const { user } = useAppSelector(state => state.authentication);
  const { session } = useAppSelector(state => state.billing);

  const handleCreateSession = () => {
    setLoad(true);
    if (user?.customer_id !== "") {
      dispatch(createPortalSession());
    }
  }

  if (session && session.session_url) {
    window.location.href = session.session_url;
  }

  return (
    <LoadingPage loading={load}>
      <Grid container>
        <Grid item xs={2}></Grid>
        <Grid item xs={6} sx={{paddingTop: "50px"}}>
          <Stack>
            <Typography variant="body2" sx={{ paddingTop: 3.25, paddingBottom: 4.5 }}>
              Your Arris account has fallen behind on payments, please update your payment method on file to resume service.
            </Typography>
            {
              !user?.customer_id ?
                <Stack direction="row" sx={{ width: "100%", justifyContent: "center" }} alignItems="center" spacing={6}>
                  <Typography variant="body2" color="primary">
                    <b>Loading</b>
                  </Typography>
                  <CircularProgress size={24} />
                </Stack> :
                <Button variant="contained" onClick={handleCreateSession}>
                  Update Payment
                </Button>
            }
          </Stack>
        </Grid>
      </Grid>
    </LoadingPage>
  );
}
